import { gettext } from '@eventbrite/i18n';
import React, { useState } from 'react';
import { LISTING_HEAP_IDS } from '../../../../constants';
import { Modal } from '../../../_shared/Modal';

import './HeroVideo.scss';

interface HeroVideo {
    alt?: string;
    url: string;
}

const Play = () => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 29 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.04801 0.739296C1.17831 0.190008 0.0444336 0.814966 0.0444336 1.84361V34.1568C0.0444336 35.1854 1.17831 35.8104 2.04802 35.2611L27.6293 19.1045C28.4408 18.5919 28.4408 17.4084 27.6293 16.8959L2.04801 0.739296Z"
            fill="white"
        />
    </svg>
);

export const HeroVideo: React.FC<HeroVideo> = ({ alt, url, children }) => {
    const [shouldShowVideo, setShouldShowVideo] = useState(false);

    return (
        <>
            <div className="video-wrapper">
                <div className="video-overlay">
                    <button
                        data-heap-id={LISTING_HEAP_IDS.HERO_VIDEO}
                        className="video-play-button"
                        aria-label="Play"
                        onClick={() => setShouldShowVideo(true)}
                    >
                        <div className="video-play-button__icon">
                            <Play />
                        </div>
                    </button>
                </div>
                {children}
            </div>
            {shouldShowVideo && (
                <Modal
                    visible={true}
                    type="simple"
                    noMinHeight={true}
                    noPadding={true}
                    onClose={() => setShouldShowVideo(false)}
                    __containerClassName="eds-modal--fit-content"
                >
                    <div className="modal-video-wrapper">
                        <iframe
                            src={`${url.split('?')[0]}?autoplay=1&mute=1`}
                            frameBorder="0"
                            allowFullScreen
                            allow="autoplay"
                            title={alt || gettext('Video content').toString()}
                            loading="lazy"
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};
